module.exports = __webpack_public_path__ + "img/5.5615e5ab.jpg";